import React, { useState, useEffect } from 'react';
import MainLayout from "../../components/layouts/MainLayout"; // Import de votre layout principal
import { message } from 'antd'; // Pour afficher les messages d'erreur et de succès
import { AdminApi } from "../../api/adminsApi" // Import de l'API (assurez-vous que cette API est définie pour récupérer l'admin et modifier son mot de passe)
import { PasswordResetSettingsApi } from "../../api/passwordResetSettingsApi";
import { Auth } from '../../utils/Auth';
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";


const SettingsView = () => {
    const abortController = new AbortController()
    const [loading, setLoading] = useState(true);
    const [loadingProfil, setLoadingProfil] = useState(true);
    const [formData, setFormData] = useState({
        name: "",
        lastname: "",
        email: "",
    });
    const [passwordData, setPasswordData] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const [otpSettings, setOtpSettings] = useState({
        otp_expire_minutes: "",
        otp_max_attempts: "",
    });
    const [loadingOtpSettings, setLoadingOtpSettings] = useState(true);
    const user = Auth.getUser()
    const [passwordVisible, setPasswordVisible] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible); // Alterner la visibilité du mot de passe
    };
    

  // Récupérer le profil de l'administrateur connecté
  const loadAdminProfile = async () => {
    try {
        const res = await AdminApi.getAdmin(`${user.user.id}`,abortController.signal);
        // Supposez que cette méthode existe pour récupérer le profil
        console.log(res.data)
        if (res && res.data) {
            setFormData({
            name: res.data.name,
            lastname: res.data.lastname,
            email: res.data.email,
            });
            setLoadingProfil(false);
        } else {
            message.error("Impossible de récupérer les informations du profil");
            setLoadingProfil(false);
        }
        } catch (error) {
            setLoadingProfil(false);
            message.error("Erreur lors du chargement du profil.");
        }
  };

  // Récupérer les réglages OTP de réinitialisation de mot de passe
  const loadOtpSettings = async () => {
    try {
        const res = await PasswordResetSettingsApi.getSettings(abortController.signal);
        if (res && res.data) {
            setOtpSettings({
                otp_expire_minutes: res.data.otp_expire_minutes,
                otp_max_attempts: res.data.otp_max_attempts,
            });
            setLoadingOtpSettings(false);
        } else {
            message.error("Impossible de récupérer les réglages de réinitialisation de mot de passe");
            setLoadingOtpSettings(false);
        }
        } catch (error) {
            setLoadingOtpSettings(false);
            message.error("Erreur lors du chargement des réglages de réinitialisation de mot de passe.");
        }
  };

  // Charger les données au démarrage du composant
  useEffect(() => {
    loadAdminProfile();
    loadOtpSettings();
  }, []);

  // Gérer les changements dans le formulaire du profil
  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Gérer les changements dans le formulaire du mot de passe
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Gérer les changements dans le formulaire des réglages OTP
  const handleOtpSettingsChange = (e) => {
    const { name, value } = e.target;
    setOtpSettings((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Soumettre le formulaire de modification de profil
  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setLoadingProfil(true);
    try {
        const payload = {
            name: formData.name,
            lastname: formData.lastname,
            email: formData.email
        };
        console.log("Payload envoyé:", payload)
        // const res = await AdminApi.updateAdmin()

      const res = await AdminApi.updateAdmin(user.user.id,JSON.stringify(payload),abortController.signal); // Supposez qu'il existe une API pour mettre à jour le profil
      if (res && res.data) {
        message.success("Profil mis à jour avec succès");
      } else {
        message.error("Échec de la mise à jour du profil");
      }
    } catch (error) {
      message.error("Erreur lors de la mise à jour du profil");
    }
    setLoadingProfil(false);
  };

  // Soumettre le formulaire de modification de mot de passe
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      message.error("Les mots de passe ne correspondent pas");
      setLoading(false);
      return;
    }
    try {
        const payload = {
            current_password:passwordData.currentPassword,
            new_password:passwordData.newPassword
        }
      const res = await AdminApi.updatePasswordAdmin(JSON.stringify(payload)); // Supposez qu'il existe une API pour modifier le mot de passe
      if (res && res.data) {
        message.success("Mot de passe mis à jour avec succès");
        setPasswordData({
            currentPassword:"",
            newPassword:"",
            confirmPassword:""
        })

      } else {
        message.error("Échec de la mise à jour du mot de passe");
      }
    } catch (error) {
      message.error("Erreur lors de la mise à jour du mot de passe");
    }
    setLoading(false);
  };

  // Soumettre le formulaire des réglages OTP de réinitialisation de mot de passe
  const handleOtpSettingsSubmit = async (e) => {
    e.preventDefault();
    setLoadingOtpSettings(true);
    try {
        const payload = {
            otp_expire_minutes: Number(otpSettings.otp_expire_minutes),
            otp_max_attempts: Number(otpSettings.otp_max_attempts),
        };
        const res = await PasswordResetSettingsApi.updateSettings(JSON.stringify(payload), abortController.signal);
        if (res && res.success) {
            message.success("Réglages mis à jour avec succès");
            setOtpSettings({
                otp_expire_minutes: res.data.otp_expire_minutes,
                otp_max_attempts: res.data.otp_max_attempts,
            });
        } else {
            message.error(res?.message || "Échec de la mise à jour des réglages");
        }
    } catch (error) {
        message.error("Erreur lors de la mise à jour des réglages");
    }
    setLoadingOtpSettings(false);
  };

  return (
    <MainLayout>
      <div className="max-w-6xl mx-auto p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Volet Profil */}
          <div className="bg-white p-4 rounded-lg shadow">
            <h2 className="text-2xl font-semibold mb-4">Profil de l'utilisateur</h2>
            <form onSubmit={handleProfileSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Nom</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleProfileChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  disabled={loadingProfil}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Prenom</label>
                <input
                  type="text"
                  name="lastname"
                  value={formData.lastname}
                  onChange={handleProfileChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  disabled={loadingProfil}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleProfileChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  disabled={loadingProfil}
                />
              </div>
              <button
                type="submit"
                className="w-full px-4 py-2 bg-africasa-secondary text-white rounded-md hover:bg-africasa-primary"
                disabled={loadingProfil}
              >
                {loadingProfil ? 'Chargement...' : 'Mettre à jour le profil'}
              </button>
            </form>
          </div>

          {/* Volet Mot de passe */}
          <div className="bg-white p-4 rounded-lg shadow">
            <h2 className="text-2xl font-semibold mb-4">Modifier le mot de passe</h2>
            <form onSubmit={handlePasswordSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Mot de passe actuel</label>
                    <input
                    type={passwordVisible ? 'text' : 'password'}
                    name="currentPassword"
                    value={passwordData.currentPassword}
                    onChange={handlePasswordChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                    disabled={loading}
                    />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Nouveau mot de passe</label>
                <div className="relative">
                    <input
                    type={passwordVisible ? 'text' : 'password'}
                    name="newPassword"
                    value={passwordData.newPassword}
                    onChange={handlePasswordChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                    disabled={loading}
                    />
                    <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-600"
                        >
                        {passwordVisible ? (
                            <EyeInvisibleOutlined className="h-5 w-5" />
                        ) : (
                            <EyeOutlined className="h-5 w-5" />
                        )}
                    </button>
                </div>
                    
                
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Confirmer le mot de passe</label>
                <div className="relative">
                <input
                  type={passwordVisible ? 'text' : 'password'}
                  name="confirmPassword"
                  value={passwordData.confirmPassword}
                  onChange={handlePasswordChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  disabled={loading}
                />
                <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-600"
                    >
                    {passwordVisible ? (
                        <EyeInvisibleOutlined className="h-5 w-5" />
                    ) : (
                        <EyeOutlined className="h-5 w-5" />
                    )}
                    </button>
                </div>
                
              </div>
              <button
                type="submit"
                className="w-full px-4 py-2 bg-africasa-secondary text-white rounded-md hover:bg-africasa-primary"
                disabled={loading}
              >
                {loading ? 'Chargement...' : 'Mettre à jour le mot de passe'}
              </button>
            </form>
          </div>

          {/* Volet Réinitialisation de mot de passe (OTP) */}
          <div className="bg-white p-4 rounded-lg shadow">
            <h2 className="text-2xl font-semibold mb-4">Réinitialisation de mot de passe (OTP)</h2>
            <form onSubmit={handleOtpSettingsSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Durée de validité du code (minutes)</label>
                <input
                  type="number"
                  name="otp_expire_minutes"
                  min="1"
                  max="1440"
                  value={otpSettings.otp_expire_minutes}
                  onChange={handleOtpSettingsChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  disabled={loadingOtpSettings}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Nombre maximum de tentatives</label>
                <input
                  type="number"
                  name="otp_max_attempts"
                  min="1"
                  max="20"
                  value={otpSettings.otp_max_attempts}
                  onChange={handleOtpSettingsChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  disabled={loadingOtpSettings}
                />
              </div>
              <button
                type="submit"
                className="w-full px-4 py-2 bg-africasa-secondary text-white rounded-md hover:bg-africasa-primary"
                disabled={loadingOtpSettings}
              >
                {loadingOtpSettings ? 'Chargement...' : 'Enregistrer'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default SettingsView;
